module.exports = __webpack_public_path__ + "img/light_10.676c8de6.png";